// =============================================================================
// PROJECTS FILTERS
// assets/js/modules/projectsFilters.js
//
// Toggle the filters drawer (open/close) + filter the project items
// (grid & list, both present in the DOM at once) by section/service.
// =============================================================================

export function init() {
    const trigger = document.getElementById('filters-trigger');
    const drawer  = document.getElementById('filters-drawer');
    if (!trigger || !drawer) return;

    trigger.addEventListener('click', toggle);
    document.addEventListener('keydown', _onKeydown);
    document.addEventListener('click', _onOutsideClick);
    drawer.addEventListener('click', _onFilterClick);
}

export function destroy() {
    const trigger = document.getElementById('filters-trigger');
    const drawer  = document.getElementById('filters-drawer');
    if (trigger) trigger.removeEventListener('click', toggle);
    if (drawer)  drawer.removeEventListener('click', _onFilterClick);
    document.removeEventListener('keydown', _onKeydown);
    document.removeEventListener('click', _onOutsideClick);
}

// -----------------------------------------------------------------------------

function toggle() {
    const trigger = document.getElementById('filters-trigger');
    const drawer  = document.getElementById('filters-drawer');
    if (!drawer) return;
    _setOpen(!drawer.classList.contains('is-open'), trigger, drawer);
}

function close() {
    const trigger = document.getElementById('filters-trigger');
    const drawer  = document.getElementById('filters-drawer');
    if (!drawer) return;
    _setOpen(false, trigger, drawer);
}

function _setOpen(open, trigger, drawer) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    trigger.classList.toggle('is-open', open);
}

function _onKeydown(e) {
    if (e.key === 'Escape') close();
}

function _onOutsideClick(e) {
    const drawer  = document.getElementById('filters-drawer');
    const trigger = document.getElementById('filters-trigger');
    const list    = drawer?.querySelector('.filters-drawer__list');
    if (
        drawer?.classList.contains('is-open') &&
        !list?.contains(e.target) &&
        !trigger?.contains(e.target)
    ) {
        close();
    }
}

// -----------------------------------------------------------------------------
// Filtering
// -----------------------------------------------------------------------------

function _onFilterClick(e) {
    const serviceEl = e.target.closest('.filters-drawer__service');
    if (serviceEl) {
        const section = serviceEl.closest('[data-filter]')?.dataset.filter;
        _applyFilter(section, serviceEl.dataset.filterService);
        return;
    }

    const labelEl = e.target.closest('.filters-drawer__section-label');
    if (labelEl) {
        _applyFilter(labelEl.closest('[data-filter]')?.dataset.filter, null);
        return;
    }

    const allEl = e.target.closest('[data-filter="all"]');
    if (allEl) _applyFilter('all', null);
}

function _applyFilter(section, service) {
    const filter = { section: section || 'all', service: service || null };

    document
        .querySelectorAll('.filters-drawer__item.is-active, .filters-drawer__section-label.is-active, .filters-drawer__service.is-active')
        .forEach(el => el.classList.remove('is-active'));

    if (filter.service) {
        const serviceEl = document.querySelector(`.filters-drawer__service[data-filter-service="${filter.service}"]`);
        serviceEl?.classList.add('is-active');
        serviceEl?.closest('[data-filter]')?.querySelector('.filters-drawer__section-label')?.classList.add('is-active');
    } else if (filter.section === 'all') {
        document.querySelector('.filters-drawer__item[data-filter="all"]')?.classList.add('is-active');
    } else {
        document.querySelector(`[data-filter="${filter.section}"] > .filters-drawer__section-label`)?.classList.add('is-active');
    }

    // Une section n'a pas de champ "section" propre sur les projets — elle filtre
    // via les services qui lui sont rattachés (cf. $sectionServices en PHP).
    let sectionServiceIds = null;
    if (!filter.service && filter.section !== 'all') {
        const sectionLi = document.querySelector(`.filters-drawer__item[data-filter="${filter.section}"]`);
        sectionServiceIds = Array.from(sectionLi?.querySelectorAll('[data-filter-service]') || [])
            .map(el => el.dataset.filterService);
    }

    document.querySelectorAll('.project-item, .project-itemlist').forEach(item => {
        const itemServices = (item.dataset.services || '').split(',').filter(Boolean);
        let match;
        if (filter.service)                match = itemServices.includes(filter.service);
        else if (filter.section === 'all') match = true;
        else if (sectionServiceIds?.length) match = itemServices.some(id => sectionServiceIds.includes(id));
        else                                match = item.dataset.section === filter.section;

        item.classList.toggle('is-filtered-out', !match);

        // Le layer média de la vue list est positionné par index depuis wave-list.js —
        // masquer aussi la media correspondante pour éviter une image flottante orpheline.
        if (item.classList.contains('project-itemlist')) {
            const media = document.querySelector(`[data-wave-media="${item.dataset.index}"]`);
            media?.classList.toggle('is-filtered-out', !match);
        }
    });

    window.dispatchEvent(new Event('resize'));
}
